import { useEffect } from "react";
import { useParams } from "react-router-dom";

export default function MediaRedirect() {
  const { name } = useParams();
  useEffect(() => {
    window.location.replace(`${process.env.REACT_APP_BACKEND_URL}/api/media/${name}`);
  }, [name]);
  return null;
}
